import React from "react";
import { useTranslation } from "react-i18next";
import { AlertCircle } from "lucide-react";
import { Card, CardContent } from "../ui/card";

const AssignmentInfoAlert = () => {
  const { t } = useTranslation();

  return (
    <Card className="border-border bg-muted/20">
      <CardContent className="pt-6">
        <div className="flex items-start gap-3">
          <AlertCircle className="h-5 w-5 text-muted-foreground mt-0.5" />
          <div className="text-sm text-muted-foreground">
            <p className="font-medium">{t("planning.assignmentsPanel.importantTitle")}</p>
            <p className="mt-1">
              {t("planning.assignmentsPanel.importantDescription")}
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default AssignmentInfoAlert;
